/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Row} from "react-bootstrap";


type FormFieldsGroupFieldsProps = {
    children?: | React.ReactChild | React.ReactChild[];
};


export const FormFieldsGroupFieldsComponent: React.FC<FormFieldsGroupFieldsProps> = ({
    children = null
}): JSX.Element => {


    return (
        <Row className={"form-fields-group-fields-component"}>
            {children}
        </Row>
    );

};


export default FormFieldsGroupFieldsComponent;
